var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89342 4.78249L8.89751 6.78658L8.90705 6.68161C8.90705 5.62865 8.05135 4.77295 6.99839 4.77295L6.89342 4.78249Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99841 3.50069C8.75438 3.50069 10.1795 4.92583 10.1795 6.6818C10.1795 7.09216 10.0968 7.48343 9.95367 7.84289L11.8146 9.70383C12.7753 8.90219 13.5324 7.86517 14 6.6818C12.8962 3.88881 10.1827 1.91016 6.99844 1.91016C6.10773 1.91016 5.25521 2.0692 4.46312 2.3555L5.83735 3.72654C6.19678 3.58658 6.58805 3.50069 6.99841 3.50069Z",
    fill: "#ABABAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.636209 1.76699L2.08679 3.21757L2.37628 3.50706C1.32652 4.32778 0.496251 5.41891 0 6.68178C1.10067 9.47477 3.81731 11.4534 6.99842 11.4534C7.98457 11.4534 8.92616 11.2626 9.78825 10.9158L10.0587 11.1862L11.9132 13.044L12.7244 12.236L1.44739 0.955811L0.636209 1.76699ZM4.15452 5.28211L5.13748 6.26507C5.10885 6.40187 5.08976 6.53863 5.08976 6.68178C5.08976 7.73473 5.94547 8.59044 6.99842 8.59044C7.14157 8.59044 7.27837 8.57135 7.41197 8.54272L8.39493 9.52568C7.97183 9.73563 7.50105 9.86289 6.99842 9.86289C5.24245 9.86289 3.81731 8.43775 3.81731 6.68178C3.81731 6.17918 3.94457 5.70837 4.15452 5.28211Z",
    fill: "#ABABAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.249e64c260cd5acb448ebbe4b12c4e26.svg";
export { ForwardRef as ReactComponent };